const { viewportSize } = window.BAO.Utils

class ProductTabs extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'panel', 'close']
  }

  connectedCallback () {
    super.connectedCallback()

    if (viewportSize() === 'xs') {
      this.openFirstTab()
    }
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists && this.els?.panel?.exists) {
      this.els.trigger.elements.forEach(triggerEl => {
        triggerEl.addEventListener('click', this.handleTrigger.bind(this))
      })
    }

    if (this.els?.close?.exists) {
      this.els.close.element.addEventListener(
        'click',
        this.handleClose.bind(this),
      )
    }

    document.addEventListener('click', e => {
      if (!window.BAO.MediaBreakpoints.isSm) return
      if (!this.classList.contains('prd-Tabs-open')) return

      if (e?.target?.dataset?.productTabsEl === 'trigger') return

      this.handleClose()
    })

    window.addEventListener('resize', this.ensureTabIsOpenOnMobile.bind(this))
  }

  handleClose () {
    this.classList.remove('prd-Tabs-open')

    if (viewportSize() !== 'xs') {
      this.els.trigger.elements.forEach(triggerEl => {
        triggerEl.setAttribute('aria-selected', false)
      })

      this.els.panel.elements.forEach(panelEl => {
        panelEl.hidden = true
      })
    }
  }

  handleTrigger = event => {
    const optionValue = event.target.dataset.value

    this.els.trigger.elements.forEach(triggerEl => {
      if (triggerEl.dataset.value === optionValue) {
        if (viewportSize() === 'xs') {
          this.classList.add('prd-Tabs-open')

          triggerEl.setAttribute('aria-selected', true)
        } else {
          const tabOpen = triggerEl.getAttribute('aria-selected') === 'true'

          this.classList.toggle('prd-Tabs-open', !tabOpen)

          triggerEl.setAttribute('aria-selected', !tabOpen)
        }
      } else {
        triggerEl.setAttribute('aria-selected', false)
      }
    })

    this.els.panel.elements.forEach(panelEl => {
      if (panelEl.dataset.value === optionValue) {
        if (viewportSize() === 'xs') {
          panelEl.hidden = false
        } else {
          const panelHidden = panelEl.hasAttribute('hidden')

          panelEl.hidden = !panelHidden
        }
      } else {
        panelEl.hidden = true
      }
    })
  }

  ensureTabIsOpenOnMobile () {
    if (viewportSize() !== 'xs') return

    if (this.classList.contains('prd-Tabs-open')) return

    this.openFirstTab()
  }

  openFirstTab () {
    this.classList.add('prd-Tabs-open')
    this.els.trigger.elements[0].setAttribute('aria-selected', true)

    this.els.panel.elements[0].hidden = false
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs)
}
